import { generateOptions } from '@/lib/generic.utils'
import { cloneDeep } from 'lodash'

export default {
  publisherOptions: state => {
    return generateOptions({ collection: cloneDeep(state.publishers) })
  },
  userOptions: state => {
    return generateOptions({
      collection: cloneDeep(state.users),
      includeNone: true,
      noneLabel: 'None',
      sort: false,
      sortBefore: true,
      sortingOptions: {
        sortDataType: 'string',
        sortBy: 'name',
        sortOrder: 'asc'
      }
    })
  },
  subjectCategoriesOptions: state => {
    return generateOptions({
      collection: cloneDeep(state.subjectCategories),
      includeNone: true,
      noneLabel: 'None',
      sort: false,
      sortBefore: true,
      sortingOptions: {
        sortDataType: 'string',
        sortBy: 'name',
        sortOrder: 'asc'
      }
    })
  },
  typeOptions: state => {
    return generateOptions({ collection: cloneDeep(state.types) })
  }
}
